import { createClient } from "@refinedev/supabase";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_KEY;

console.log('Environment Variables:', {
  SUPABASE_URL: SUPABASE_URL ? '設定済み' : '未設定',
  SUPABASE_KEY: SUPABASE_KEY ? '設定済み' : '未設定',
});

if (!SUPABASE_URL || !SUPABASE_KEY) {
  const error = new Error(
    `Required environment variables are not set.\n` +
    `VITE_SUPABASE_URL: ${SUPABASE_URL ? 'set' : 'not set'}\n` +
    `VITE_SUPABASE_KEY: ${SUPABASE_KEY ? 'set' : 'not set'}`
  );
  console.error('Supabase Configuration Error:', error);
  throw error;
}

export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_KEY, {
  db: {
    schema: "public",
  },
  auth: {
    persistSession: true,
  },
});
